import { sendCloseContract } from '../../lib/services/mobivers/api';
import { AppStore, DispatchThunkAny } from '../../types/redux';
import { log } from '../../utils/logger';
import { SELECTED_NOW } from "../reducers/collectedStateReducer";
import {ApiError} from "../../types/api";
export const CONTRACT_FINALIZED_BY_EMAIL = 'CONTRACT_FINALIZED_BY_EMAIL';

export function finishByEmailProzess(): (
	dispatch: DispatchThunkAny,
	getState: any
) => Promise<void> {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		try {
			const store: AppStore = { dispatch, getState };
			const { contractWizard } = store.getState();
			contractWizard.isLoading = true;
			dispatch({ type: SELECTED_NOW });
			await sendCloseContract(store);
			dispatch({ type: CONTRACT_FINALIZED_BY_EMAIL });

			return Promise.resolve();
		} catch (error ) {
			log('Error while sending email contract', error);

			return Promise.reject(
				(error as ApiError)?.error ?? 'Ein unbekannter Fehler ist aufgetreten.'

				// error ?? 'Ein unbekannter Fehler ist aufgetreten.'
				// return Promise.reject(

			);
		}
	};
}
